// Canonical list of loggable maintenance service types.
// Kept in sync with backend/app.py's MAINTENANCE_INTERVALS and VALID_SERVICE_TYPES.
export const SERVICE_TYPE_OPTIONS = [
  "Oil Change",
  "Brake Pads",
  "Tire Rotation",
  "Battery Replacement",
  "Spark Plugs",
  "Coolant Flush",
  "Transmission Fluid",
  "Cabin Air Filter",
  "Inspection",
  "Alignment",
  "Tire Change",
  "Power Steering Fluid",
  "Serpentine Belt",
  "Wiper Blades",
  "Brake Fluid",
  "Engine Replacement",
  "Transmission Replacement",
  "Brake Caliper Replacement",
  "Strut Replacement",
  "Wheel Balance",
  "Alternator Replacement",
  "Engine Air Filter Replacement",
  "Headlight Bulb Replacement",
  "Windshield Crack Repair",
  "Windshield Replacement",
];

export default SERVICE_TYPE_OPTIONS;
